'use client';

import React, { useCallback } from 'react';
import { DynamicCriteriaGeneratorV2 } from 'src/components';
import { LOCATION } from 'src/hooks/filters/constants';
import { useDrawer } from 'src/hooks/drawers/useDrawer';
import { CriteriaComponentType } from 'src/redux/slices/aiListGeneratorSlice';
import { TemplateDrawer } from 'src/components/DynamicCriteriaGenerator/components';

interface StrategyListGeneratorProps {
  allowedTypes?: CriteriaComponentType[];
  location?: string;
  strategyType?: string;
}

const StrategyListGenerator: React.FC<StrategyListGeneratorProps> = ({
  allowedTypes,
  location = LOCATION.STRATEGY,
  strategyType,
}) => {
  const { isDrawerOpen, closeDrawer } = useDrawer();

  const handleCloseDrawer = useCallback(() => {
    closeDrawer('strategy-template-drawer');
  }, [closeDrawer]);

  return (
    <div>
      <DynamicCriteriaGeneratorV2
        location={location}
        allowedTypes={allowedTypes}
      />

      {strategyType && (
        <TemplateDrawer
          isOpen={isDrawerOpen('strategy-template-drawer')}
          onClose={handleCloseDrawer}
          strategyType={strategyType}
          location={location}
        />
      )}
    </div>
  );
};

export default StrategyListGenerator;
